import { InjectionToken } from '@angular/core';

export interface AnalyticsDefaultParameters {
  business: string;
  business_channel: string;
  environment: 'logado' | 'deslogado' | string;
}

export interface AnalyticsConfig {
  sdkUrl: string;
  gtmId: string;
  defaultParameters?: AnalyticsDefaultParameters;
  loadStrategy?: 'bootstrap' | 'defer' | 'idle';
  timeoutMs?: number; // ex: 10000
  scriptNonce?: string;
  engagement?: any;
  webview?: boolean;
  fullstory?: any;
}

export interface AnalyticsSdk {
  setDefaultParameters(params: { analytics: { parameters: AnalyticsDefaultParameters } }): void;
  track(event: { analytics: { event_name: string; parameters: any } }): void;
  setUserProperties(properties: { analytics: any }): void;
  removeUserProperties(): void;
  removeDefaultParameter(parameter: string): void;
  removeDefaultParameters(parameters: string[]): void;
}

export const ANALYTICS_CONFIG = new InjectionToken<AnalyticsConfig>('ANALYTICS_CONFIG');
